import React from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Form, Input, Space, Typography } from "@payping/web-components";
import { DashboardChecksTypeEnum } from "@payping/api";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import { useHandleNavigationURL, useSaveToRedux } from "../../utils";
import { selectAtom } from "jotai/utils";
import { settingsBusinessAtom } from "@/mobile/Settings/state";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditOfficialBusinessSabtNumber: React.FC = () => {
  const { t } = useAppTranslation();
  const [form] = Form.useForm();
  const checks = useAppSelector((state) => state.user.checks);
  const isSabtDisabled = checks?.businessRegistrationStatus === DashboardChecksTypeEnum.Confirmed;
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const sabtNumberApi = useAppSelector((state) => state.user.businessInfo?.sabtNumber);

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        placement={"bottom"}
        open={true}
        height={"100%"}
        title={`${t("edit")} / ${t("settings.business.sabtNumber")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Space direction={"vertical"}>
          <Form
            onFinish={({ sabtNumber }) =>
              saveToRedux({
                nextUrlForMobileRegisterURL:
                  DashboardRoutes.register.mEditBusiness.officialBusinessRegistrationDate.url,
                nextUrlForEdit: DashboardRoutes.settings.mEditBusiness.officialBusinessRegistrationDate.url,
                fieldName: "sabtNumber",
                fieldValue: sabtNumber,
                setIsDrawerOpen: () => {},
              })
            }
            form={form}
            initialValues={{ sabtNumber: mobileFormEditState.sabtNumber ?? sabtNumberApi }}
          >
            <Form.Item label={t("profile.sabtNumber")} name={"sabtNumber"} rules={[{ required: true }]}>
              <Input
                onlyNumbers
                disabled={!form.getFieldValue("sabtNumber") ? false : isSabtDisabled}
                canStartWithZero
              />
            </Form.Item>
          </Form>
          <Typography.Text type={"secondary"}>{t("mobileEditPersonal.nameDesc")}</Typography.Text>
        </Space>
      </Drawer>
      <EditActionButtons onAccept={form.submit} acceptText={t("next")} />
    </>
  );
};

export default MobileEditOfficialBusinessSabtNumber;
